// payments.service — rekonsiliasi 2 langkah + edit tagihan + histori + gating izin.
import { currentUser } from '@core/session';
import { canMarkLunas, canVerify, canEditBayar } from '@domain/access';
import { wajibJatuhTempo } from '@domain/money';
import { logAudit } from '@core/audit';
import type { Role } from '@core/types';
import * as repo from './payments.repo';
import { cairkanBonus } from '@modules/crm/afiliasi.service';

function guard(fn: (r: Role) => boolean, msg: string): void {
  const u = currentUser();
  if (!u || !fn(u.role)) throw new Error(msg);
}

export async function markLunas(no: string, via?: string): Promise<void> {
  guard(canMarkLunas, 'Pelunasan hanya oleh CS (atau Owner/Manager) — Finance memverifikasi, bukan melunasi.');
  await repo.markLunas(no, via);
}

export async function verifyBayar(no: string): Promise<void> {
  guard(canVerify, 'Verifikasi hanya oleh Finance/Manager/Owner.');
  await repo.verify(no);
  // Bonus rekomendasi baru cair DI SINI — setelah uangnya benar-benar masuk dan dicek Finance.
  // Best-effort: gagal memberi bonus tak boleh menggagalkan verifikasi pembayaran.
  try {
    const cid = await repo.customerIdOf(no);
    if (cid) await cairkanBonus(cid, no);
  } catch { /* bonus menyusul; pembayaran tetap sah */ }
}

export interface BillingEdit { biaya: number; dp: number; cara: string; jatuhTempo: string | null; unsettle: boolean; }

export async function editBilling(no: string, e: BillingEdit): Promise<void> {
  guard(canEditBayar, 'Edit tagihan hanya Owner/Manager.');
  if (e.biaya < 0 || e.dp < 0) throw new Error('Nilai tidak valid.');
  if (e.dp > e.biaya) throw new Error('DP tidak boleh melebihi tagihan.');
  if (wajibJatuhTempo(e.cara) && !e.jatuhTempo) throw new Error('Tempo (Toko) wajib jatuh tempo.');
  await repo.editBilling(no, { biaya: e.biaya, dp: e.dp, cara_bayar: e.cara, jatuh_tempo: e.jatuhTempo, unsettle: e.unsettle });
  await logAudit({ action: e.unsettle ? 'BILLING_UNSETTLE' : 'BILLING_EDIT', module: 'ticket', refId: no, meta: { biaya: e.biaya, dp: e.dp, cara: e.cara, unsettle: e.unsettle } });
}

export const history = (no: string): Promise<repo.LogItem[]> => repo.getHistory(no);
